<template>
	<div>
		<breadcrumb :routerList="[{to:'/dingd/purchaselist',title:'采购订单列表'},{title:'发票信息维护 '}]"/>
		<div class="h-content">
			<div class="h-piece">
				<div class="l-linkBox">
					<div class="l-linkl">
						<div class="l-linkscreen">
							<div class="l-linktext">付款订单</div>
							<el-input class="l-linkinput" v-model="fkdd" placeholder="请输入"></el-input>
							<el-button class="h-btn h-formBtn" @click="checkData1">检索</el-button>
						</div>
						<div class="l-linktable">
							<el-table
							    ref="multipleTable"
								@selection-change="handleSelectionChange1"
							    :data="tableData1"
							    stripe
							    style="width: 100%"
								:border="true"
								max-height="220"
							    >
							    <el-table-column
							    type="selection"
							    width="45"
								fixed
							    >
							    </el-table-column>
							    <el-table-column
							        prop="code"
									:show-overflow-tooltip="true"
							        label="订单号">
							    </el-table-column>
								<el-table-column
								    prop="totalPrice"
									:show-overflow-tooltip="true"
								    label="订单金额">
								</el-table-column>
								<el-table-column
								    label="操作">
									<template slot-scope="scope">
										<el-button
											type="text"
											size="small"
											class="h-tableLink h-btn" @click="deltable1(scope.$index)">
											删除
										</el-button>
									</template>
								</el-table-column>
							</el-table>
							<div class="h-tableAdd" style="cursor: pointer;" @click="adddata1">
							    <a style="background-size: 0.3rem;">新增</a>
							</div>
						</div>
					</div>
					<div class="l-linkc">
						<!-- <el-button class="h-btn h-formBtn"><img src="../../assets/images/l_lj.png" alt="">关联</el-button> -->
						<div v-if="
							(tableData1&&tableData1.length>0) ||
							(tableData2&&tableData2.length>0)"
							 :style="{
								 'marginTop':
								 tableData1.length > 4?'1.8rem':
								 (tableData1.length > 3?'1.4rem':
									(tableData1.length > 2?'1.6rem':
										(tableData1.length > 1?'1.4rem':
											(tableData1.length > 0?'1.2rem':'1.2rem')
										)
									)
								 )

							 }"
							 @click="links"
							 class="l-linkgls">
							<img src="../../assets/images/l_lj.png" alt="" style="width: 0.2rem;height: 0.2rem;">
							<div style="margin-left: 0.05rem;">关联</div>
						</div>
					</div>
					<div class="l-linkr">
						<div class="l-linkscreen">
							<div class="l-linktext">发票号</div>
							<el-input class="l-linkinput" v-model="fph" placeholder="请输入"></el-input>
							<el-button class="h-btn h-formBtn" @click="checkData2">检索</el-button>
						</div>
						<div class="l-linktable">
							<el-table
							    ref="multipleTable"
								@selection-change="handleSelectionChange2"
							    :data="tableData2"
							    stripe
							    style="width: 100%"
								:border="true"
								max-height="220"
							    >
							    <el-table-column
									type="selection"
									width="45"
							    >
							    </el-table-column>
							    <el-table-column
							        prop="invoiceNo"
									:show-overflow-tooltip="true"
							        label="发票号">
							    </el-table-column>
								<el-table-column
								    prop="invoiceDate"
									:show-overflow-tooltip="true"
								    label="发票日期">
									<template slot-scope="scope">
										<div>{{scope.row.invoiceDate?scope.row.invoiceDate.substring(0,10):''}}</div>
									</template>
								</el-table-column>
								<el-table-column
								    prop="fpje"
									:show-overflow-tooltip="true"
								    label="发票金额">
								</el-table-column>
								<!--<el-table-column-->
								    <!--prop="fj"-->
									<!--:show-overflow-tooltip="true"-->
								    <!--label="附件">-->
								<!--</el-table-column>-->
                                <el-table-column
                                        label="附件"
                                        width="180"
                                >
                                    <template slot-scope="scope">
                                        <brupload
                                                :refid=scope.row.invoiceNo
                                                reftype="发票维护附件"
                                                :showtime="false"
                                        >
                                        </brupload>
                                    </template>
                                </el-table-column>
								<el-table-column
								    label="操作">
									<template slot-scope="scope">
										<el-button
											type="text"
											size="small"
											class="h-tableLink h-btn" @click="eddit(scope.row,scope.$index)">
											编辑
										</el-button>
										<el-button
											type="text"
											size="small"
											class="h-tableLink h-btn" @click="deltable2(scope.$index,scope.row)">
											删除
										</el-button>
									</template>
								</el-table-column>
							</el-table>
							<div class="h-tableAdd" style="cursor: pointer;" @click="adddata2">
							    <a style="background-size: 0.3rem;">新增</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="h-content">
			<div class="h-piece">
				<div class="h-pieceTitle2 " style="margin-bottom:0.2rem">
				    <h1>链接结果</h1>
				</div>

				<div class="l_linkqiehuan">
					<div :class="{'active':qieindex == index}" class="l_linkqies" v-for="(item,index) in qiehuanlist" :key="index" @click="qiehuanbtn(index)">{{item}}</div>
				</div>
				<div v-if="qieindex == 0">
					<div v-if="linklistsddh && linklistsddh.length>0" class="l-linkresultbox">
						<div :style="{'marginBottom':linklistsddh.length==1?'0':'0.2rem'}" class="l-linkresults" v-for="(item,index) in linklistsddh" :key="index">
							<div class="l-linkresultl">
								<div class="l-linkresultltext">付款订单</div>
								<div class="l-linkresultlnums">
									<div class="l-linkresultlnumstext">{{item.code}}</div>
									<img @click="delfkddsddh(item)" src="../../assets/images/jw_jbclock.png" alt="" style="width: 0.15rem;height: 0.2rem;cursor: pointer;">
								</div>
							</div>
							<div class="l-linkresultc">
								<img src="../../assets/images/l_gl.png" alt="" style="width: 0.18rem;height: 0.18rem;cursor: pointer;">
							</div>
							<div class="l-linkresultr">
								<div class="l-linkresultltext">发票号</div>
								<div class="l-linkresultlnums l-rights" v-for="(items,indexs) in item.list" :key="indexs">
									<div class="l-linkresultlnumstext">{{items}}</div>
									<img @click="delfpgsddh(item,items)" src="../../assets/images/l_dlj.png" alt="" style="width: 0.18rem;height: 0.18rem;cursor: pointer;">
								</div>
							</div>
							<div class="l_linkimgs" @click="addfph(item.code)">
								<img src="../../assets/images/l_adddfh.png" alt="" style="width: 0.25rem;">
							</div>
						</div>
					</div>
				</div>
				<div v-if="qieindex == 1">
					<div v-if="linklistsfph && linklistsfph.length>0" class="l-linkresultbox">
						<div :style="{'marginBottom':linklistsfph.length==1?'0':'0.2rem'}" class="l-linkresults" v-for="(item,index) in linklistsfph" :key="index">
							<div class="l-linkresultl">
								<div class="l-linkresultltext">发票号</div>
								<div class="l-linkresultlnums">
									<div class="l-linkresultlnumstext">{{item.code}}</div>
									<img @click="delfkddsfph(item)" src="../../assets/images/jw_jbclock.png" alt="" style="width: 0.15rem;height: 0.2rem;cursor: pointer;">
								</div>
							</div>
							<div class="l-linkresultc">
								<img src="../../assets/images/l_gl.png" alt="" style="width: 0.18rem;height: 0.18rem;cursor: pointer;">
							</div>
							<div class="l-linkresultr">
								<div class="l-linkresultltext">付款订单</div>
								<div class="l-linkresultlnums l-rights" v-for="(items,indexs) in item.list" :key="indexs">
									<div class="l-linkresultlnumstext">{{items}}</div>
									<img @click="delfpgsfph(item,items)" src="../../assets/images/l_dlj.png" alt="" style="width: 0.18rem;height: 0.18rem;cursor: pointer;">
								</div>
							</div>
							<div class="l_linkimgs" @click="addfkdd(item.code)">
								<img src="../../assets/images/l_adddfh.png" alt="" style="width: 0.25rem;">
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!--<div class="h-content">-->
			<!--<div class="h-piece">-->
				<!--<div class="h-pieceTitle2 " style="margin-bottom:0.2rem">-->
				    <!--<h1>关联记录</h1>-->
				<!--</div>-->
				<!--<el-timeline>-->
					<!--<el-timeline-item-->
				      <!--v-for="(activity, index) in activities"-->
				      <!--:key="index"-->
				      <!--:icon="activity.icon"-->
				      <!--:type="activity.type"-->
					  <!--:class="{'l_timeline':activity.flag}"-->
				      <!--:size="activity.size">-->
					  <!--<span>{{activity.time}}</span>-->
					  <!--<span style="margin-left: 0.4rem;">{{activity.content}}</span>-->
					<!--</el-timeline-item>-->
				<!--</el-timeline>-->
			<!--</div>-->
		<!--</div>-->


		<el-dialog :close-on-click-modal="false" :visible.sync="dialogFormVisible1" class="h-dialog2 l-formlines">
		    <div class="h-dialogImg">
		        <div class="h-disTable">
		            <div class="h-tableCell">
		                <h1>新增付款订单</h1>
		            </div>
		        </div>
		    </div>
		    <div class="h-formLine">
		        <el-form ref="form" :model="fkddform" :inline="true" class="demo-ruleForm h-formbLine h-dialogForm">
					<el-form-item  label="订单号" class="h-elformWrap-2">
						<el-input v-model="fkddform.code" placeholder="请填写订单号"></el-input>
					</el-form-item>
		            <!--<el-form-item label="订单金额" class="h-elformWrap-2">-->
		               <!--<el-input v-model="fkddform.ddje" placeholder="请填写订单金额"></el-input>-->
		            <!--</el-form-item>-->
		        </el-form>
		    </div>
		    <div slot="footer" class="dialog-footer">
				<el-button class="h-btn h-formBtn h-bgwhite" @click="cancel1">取消</el-button>
				<el-button class="h-btn h-formBtn" type="primary" @click="saveTo1">确定</el-button>
		    </div>
		</el-dialog>
		<el-dialog :close-on-click-modal="false" :visible.sync="dialogFormVisible2" class="h-dialog2 wuliu">
		    <div class="h-dialogImg">
		        <div class="h-disTable">
		            <div class="h-tableCell">
		                <h1>{{fphadd}}</h1>
		            </div>
		        </div>
		    </div>
		    <div class="h-formLine">
		        <el-form ref="form" :model="fpform" :inline="true" class="demo-ruleForm h-formbLine h-dialogForm">
					<el-form-item  label="发票号" class="h-elformWrap-2">
						<el-input :disabled="fphflag" v-model="fpform.invoiceNo" placeholder="请填写发票号"></el-input>
					</el-form-item>
		            <el-form-item label="发票日期" class="h-elformWrap-2">
						<el-date-picker
								placeholder="请选择"
								v-model="fpform.invoiceDate"
								clearable
								type="date"
								value-format="yyyy-MM-dd" >
						</el-date-picker>
		            </el-form-item>
					<el-form-item label="发票金额" class="h-elformWrap-2">
					   <el-input v-model="fpform.fpje" placeholder="请填写发票金额"></el-input>
					</el-form-item>
					<el-form-item label="附件" class="h-elformWrap-1">
					   <brupload :refid="fpform.invoiceNo" reftype="发票维护附件" :showtime="false" uploadflag delflag></brupload>
					</el-form-item>
		        </el-form>
		    </div>
		    <div slot="footer" class="dialog-footer">
				<el-button class="h-btn h-formBtn h-bgwhite" @click="cancel2">取消</el-button>
				<el-button class="h-btn h-formBtn" type="primary" @click="saveTo2">确定</el-button>
		    </div>
		</el-dialog>
		<el-dialog :close-on-click-modal="false" :visible.sync="dialogFormVisible3" width="38%" class="body_dilog ljjdiolog" title="选择付款订单">
			<div class="h-rowIn" >
			    <div class="h-rowBox">
			        <div class="h-rowCon" style="padding-bottom: 0.8rem;">
			            <div class="h-formBox" style="display: flex;justify-content: flex-end;">
			                <el-form :inline="true" :model="q1" class="demo-form-inline h-formBorder">
			                    <el-form-item label="付款订单">
			                        <el-input clearable v-model="q1.code"></el-input>
			                    </el-form-item>
			                    <el-form-item class="h-formBtnOut">
			                        <el-button type="primary"  icon="el-icon-search" @click="search1">搜索</el-button>
			                        <el-button type="primary" icon="el-icon-plus" @click="select1">选择</el-button>
			                    </el-form-item>
			                </el-form>
			            </div>
						<el-table
						    ref="multipleTable"
							@selection-change="handleSelectionChange3"
						    :data="tableData3"
						    stripe
						    style="width: 100%"
							:border="true"
							max-height="220"
						    >
						    <el-table-column
						    type="selection"
						    width="45"
							fixed
						    >
						    </el-table-column>
						    <el-table-column
						        prop="code"
								:show-overflow-tooltip="true"
						        label="订单号">
						    </el-table-column>
							<el-table-column
							    prop="totalPrice"
								:show-overflow-tooltip="true"
							    label="订单金额">
							</el-table-column>
						</el-table>
						<div class="h-pagination2 ljjpaginations" style="margin-top: 0.2rem;">
						    <pagination :page="q1" @query="querydd"/>
						</div>
					</div>
				</div>
			</div>
		</el-dialog>
		<el-dialog :close-on-click-modal="false" :visible.sync="dialogFormVisible4" width="38%" class="body_dilog ljjdiolog" title="选择发票号">
		    <div class="h-rowIn" >
		        <div class="h-rowBox">
		            <div class="h-rowCon" style="padding-bottom: 0.8rem;">
		                <div class="h-formBox" style="display: flex;justify-content: flex-end;">
		                    <el-form :inline="true" :model="q2" class="demo-form-inline h-formBorder">
		                        <el-form-item label="发票号">
		                            <el-input clearable v-model="q2.code"></el-input>
		                        </el-form-item>
		                        <el-form-item class="h-formBtnOut">
		                            <el-button type="primary"  icon="el-icon-search" @click="search2">搜索</el-button>
		                            <el-button type="primary" icon="el-icon-plus" @click="select2">选择</el-button>
		                        </el-form-item>
		                    </el-form>
		                </div>
						<el-table
						    ref="multipleTable"
							@selection-change="handleSelectionChange4"
						    :data="tableData4"
						    stripe
						    style="width: 100%"
							:border="true"
							max-height="220"
						    >
						    <el-table-column
								type="selection"
								width="45"
						    >
						    </el-table-column>
						    <el-table-column
						        prop="invoiceNo"
								:show-overflow-tooltip="true"
						        label="发票号">
						    </el-table-column>
							<el-table-column
							    prop="invoiceDate"
								:show-overflow-tooltip="true"
							    label="发票日期">
							</el-table-column>
							<el-table-column
							    prop="fpje"
								:show-overflow-tooltip="true"
							    label="发票金额">
							</el-table-column>
						</el-table>
						<div class="h-pagination2 ljjpaginations" style="margin-top: 0.2rem;">
						    <pagination :page="q2" @query="queryfp"/>
						</div>
					</div>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import ss from '../../api/SystemService'
	export default {
		data(){
			return{
				fphadd:'新增发票号',
				fphflag:false,
				q1:{
					pageSize:10,
					pageNo:1,
					total:0,
					code:''
				},
				q2:{
					pageSize:10,
					pageNo:1,
					total:0,
					code:'',
				},
                multipleSelection: [],
				// 切换
				qiehuanlist:['订单号','发票号'],
				qieindex:'',
				activities:[
					// {
					// 	content: '张三链接了订单号CG0001516与发票号CG0001504、CG0001517、CG0001508的关联',
					// 	size: 'large',
					// 	time: '2020-03-10  10:35'
					// },
					// {
					// 	content: '张三链接了订单号CG0001516与发票号CG0001504、CG0001517、CG0001508的关联',
					// 	size: 'large',
					// 	icon: '.el-icon-more',
					// 	time: '2020-03-10  10:35'
					// },
					// {
					// 	content: '张三链接了订单号CG0001516与发票号CG0001504、CG0001517、CG0001508的关联',
					// 	size: 'large',
					// 	flag: true,
					// 	time: '2020-03-10  10:35'
					// }
				],
				// 刚进来的订单
				ddlist:[],
				fkdd:'',
				// 筛选
				fph:'',
				// 付款订单
				tableData1:[],
				// 发票号
				tableData2:[],
				// 付款订单选择列表
				multipleSelection1:[],
				multipleSelection2:[],
				// 付款订单新增
				dialogFormVisible1:false,
				fkddform:{
					code:'',
					ddje:''
				},
				// 发票号新增
				dialogFormVisible2:false,
				fpform:{
					invoiceNo:'',
					fpje:'',
					invoiceDate:''
				},
				linklistsddh:[],
				linklistsfph:[],

				onelist:[],
				twolist:[],

				dialogFormVisible3:false,
				dialogFormVisible4:false,
				// 付款订单选择列表
				multipleSelection3:[],
				multipleSelection4:[],
				tableData3:[],
				tableData4:[],
				fkddcode:'',
				fphcode:'',
				fphindex:''
			}
		},
		created() {
			var sss = JSON.parse(sessionStorage.getItem("list"));
			console.log(sss)
			if(sss && sss.length>0){
				this.ddlist = sss;
			}else{
				this.ddlist = this.$route.params.list;
			}
			// console.log(this.$route.params,"看看输出是啥");
			// this.ddlist = this.$route.params.list;
			// console.log("this.ddlist======",this.ddlist)
			this.shuju()
			// this.queryd()
		},
		mounted() {

		},
		methods:{
		    shuju(){
				if(this.ddlist && this.ddlist.length>0){
					var idlist = [];
					for(var i=0;i<this.ddlist.length;i++){
						console.log(this.ddlist[i],"!!!!!!!!!!!")
					        idlist.push(this.ddlist[i].code);
					}
					var list =idlist.join(';')
					console.log("list===",list)
					console.log("idlist===",idlist)
					//前台传后台采购编码组成的字符串，以;分割
					this.infkdd(list);
				}
                
			},
			// 刚进入订单数据获取
			infkdd(a){
				ss.orderCgService.selectOrderAndMoney(a).then(rd => {
				    console.log("rd=======",rd)
					var obj1 = {};
					var obj2 = {};
				    for(var i=0;i<rd.length;i++){
						this.tableData1.push({
							code:rd[i].code,
							totalPrice:rd[i].totalPrice
						})
						if(rd[i].invoiceNo || rd[i].fpje || rd[i].invoiceDate){
							this.tableData2.push({
								invoiceNo:rd[i].invoiceNo,
								fpje:rd[i].fpje,
								invoiceDate:rd[i].invoiceDate,
							})
						}else{
							this.tableData2 = [];
						}
						
				    }
					this.tableData1 = this.distinct(this.tableData1);
					this.tableData2 = this.distinct(this.tableData2);
					this.getgldata();
					console.log(this.tableData2,"//////")
					
				});
			},
			// 订单列表数据绑定
			// queryd(){
			// 	ss.orderCgService.selectOrder(this.q1).then(rd => {
			// 		console.log(rd)
			// 	});
			// },

			// 切换
			qiehuanbtn(index){
				this.qieindex = index;

			},
			// 数组去重
			distinct(arr) {
			    var unique = {};
				arr.forEach(function(a){ unique[ JSON.stringify(a) ] = 1 });
				arr= Object.keys(unique).map(function(u){return JSON.parse(u) });
				return arr
			},
            //订单列表查询
            querydd(){
                ss.orderCgService.selectOrder(this.q1).then(rd => {
                    console.log("rd=======",rd)
                    this.q1.total = rd.total;
                    this.tableData3 = rd.records;
                });
            },
            //发票列表查询
            queryfp(){
                ss.orderCgService.selectFp(this.q2).then(rd => {
                    console.log("rd=======",rd)
                    this.q2.total = rd.total;
                    this.tableData4 = rd.records;
                });
            },
			// 关联
			links(){
				if((this.multipleSelection1 && this.multipleSelection1.length>0)&&this.multipleSelection2 && this.multipleSelection2.length>0){

// 					this.onelist = this.multipleSelection1;
// 					this.twolist = this.multipleSelection2;
// 
// 					var obj1 = {};
// 					for(var i=0;i<this.onelist.length;i++){
// 						obj1.code = this.onelist[i].code;
// 						obj1.list = this.twolist;
// 						this.linklistsddh.push(obj1)
// 					}
// 					this.distinct(this.linklistsddh)
// 
// 					var obj2 = {};
// 					for(var i=0;i<this.twolist.length;i++){
// 						obj2.code = this.twolist[i].code;
// 						obj2.list = this.onelist;
// 						this.linklistsfph.push(obj2)
// 					}
// 					this.distinct(this.linklistsfph)
					//关联的时候将订单号和发票号根据勾选情况将两个对象集合组成一个对象传给后台，后台传回map集合--先注释
					//fpList：发票集合
					//ddList：订单集合
					var obj = {
						ddlist:this.multipleSelection1,
						fplist:this.multipleSelection2
					}
					console.log(obj,"////////////////")
                    ss.orderCgService.saveInvoiceAndOrder(obj).then(rd => {
                        console.log("rd=======",rd)
						if(rd.f){
							this.getgldata()
						}
                    });
				}else{
					this.$msg.msge('请选择付款订单/发票号,再进行关联!!')
				}
			},
			// 关联后返回的数据获取
			getgldata(){
				this.linklistsfph = [];
				this.linklistsddh = [];
				if(this.tableData1[0].code){
					var obj = {
						ddlist:this.tableData1,
						fplist:this.tableData2
					}
				}else{
					var obj = {
						ddlist:[],
						fplist:this.tableData2
					}
					this.tableData1 = [];
				}
				
				ss.orderCgService.saveInvoicejilu(obj).then(rd => {
				    console.log(rd,"////////////////////")
					for(var s in rd.fpList){
						this.linklistsfph.push({
							code:s,
							list:rd.fpList[s]
						})
					}
					for(var s in rd.ddList){
						this.linklistsddh.push({
							code:s,
							list:rd.ddList[s]
						})
					}
				});
			},
			// 检索订单
            checkData1(){
				this.tableData1 =[];
				this.tableData2 =[];
			    console.log("this.fkdd===",this.fkdd)
				if(this.fkdd){
					this.infkdd(this.fkdd);
				}
			},
			// 检索发票号
			checkData2(){
				this.tableData1 = [];
				this.tableData2 = [];
				console.log("q.fph==",this.fph)
                ss.orderCgService.selectFph(this.fph).then(rd => {
                    console.log("rd=======",rd)
                    var obj1 = {};
                    var obj2 = {};
                    for(var i=0;i<rd.length;i++){
                    	this.tableData1.push({
                    		code:rd[i].code,
                    		totalPrice:rd[i].totalPrice
                    	})
                    	if(rd[i].invoiceNo || rd[i].fpje || rd[i].invoiceDate){
                    		this.tableData2.push({
                    			invoiceNo:rd[i].invoiceNo,
                    			fpje:rd[i].fpje,
                    			invoiceDate:rd[i].invoiceDate,
                    		})
                    	}else{
                    		this.tableData2 = [];
                    	}
                    	
                    }
                    this.tableData1 = this.distinct(this.tableData1);
                    this.tableData2 = this.distinct(this.tableData2);
					this.getgldata();
                    console.log(this.tableData2,"//////")
                });
			},
			// 选择
			handleSelectionChange1(val) {
			    this.multipleSelection1 = val;
			},
			handleSelectionChange2(val) {
			    this.multipleSelection2 = val;
			},
			handleSelectionChange3(val) {
			    this.multipleSelection3 = val;
			},
			handleSelectionChange4(val) {
			    this.multipleSelection4 = val;
			},
			// 新增付款订单
			adddata1(){
				this.fkddform.code = ''
				this.dialogFormVisible1 = true;
			},
			// 取消
			cancel1(){
				this.dialogFormVisible1 = false;
			},
			// 确认
			saveTo1(){
				this.dialogFormVisible1 = false;
				if(this.fkddform.code){
					var str = '';
					for(var i=0;i<this.tableData1.length;i++){
						str += this.tableData1[i].code+';'
					}
					this.infkdd(str + this.fkddform.code + ';');
				}
			},
			// 新增发票号
			adddata2(){
				this.fpform.invoiceNo = '';
				this.fpform.fpje = '';
				this.fpform.invoiceDate = '';
				this.fphadd = '新增发票号';
				this.fphflag = false;
				this.dialogFormVisible2 = true;
			},
			eddit(v,index){
				console.log(v,index)
				this.fpform.invoiceNo = v.invoiceNo;
				this.fpform.fpje = v.fpje;
				this.fpform.invoiceDate = v.invoiceDate;
				this.fphindex = index;
				this.fphadd = '修改发票号';
				this.fphflag = true;
				this.dialogFormVisible2 = true;
			},
			// 取消
			cancel2(){
				this.dialogFormVisible2 = false;
			},
			// 确认
			saveTo2(){
				this.dialogFormVisible2 = false;
				if(this.fphflag){
					ss.orderCgService.xiugaiFpxinxi(this.fpform).then(rd => {
					    console.log("rd=======",rd)
						var obj = {
							invoiceNo:rd.invoiceNo,
							fpje:rd.fpje,
							invoiceDate:rd.invoiceDate,
						}
						this.$set(this.tableData2,this.fphindex,obj)
					});
				}else{
					if(this.fpform.invoiceNo || this.fpform.fpje || this.fpform.invoiceDate){
					    console.log(this.fpform,"11111111111")
					    //新增发票号，有则提示，没有则保存发票信息
					    ss.orderCgService.insertFpha(this.fpform).then(rd => {
					        console.log("rd=======",rd)
							this.tableData2.push({
								invoiceNo:rd.invoiceNo,
								fpje:rd.fpje,
								invoiceDate:rd.invoiceDate,
							})
					    });
					}else{
						this.$msg.msge('请输入')
					}
				}
				
			},
			// 删除
			deltable1(index){
				this.tableData1.splice(index,1);
				var str = '';
				for(var i=0;i<this.tableData1.length;i++){
					str += this.tableData1[i].code+';'
				}
				this.infkdd(str);
			},
			deltable2(index,item){
                this.$msg.confirm("确认删除该发票号并解除该发票号关联的所有订单？",()=>{
                    ss.orderCgService.deletefph(item.invoiceNo).then(rd => {

                    });
                    var str = '';
                    for(var i=0;i<this.tableData2.length;i++){
                        str += this.tableData2[i].invoiceNo+';'
                    }
                    this.fph = str;
                    this.checkData2();
                })
				//this.tableData2.splice(index,1);
			},
			// 解绑前
			delfkddsddh(item){
				console.log(item.list)
				this.$msg.confirm("确认全部解绑与该订单号关联的发票号？",()=>{
					var str = '';
					for(var i=0;i<item.list.length;i++){
						str += item.list[i]+';'
					}
				    ss.orderCgService.jiechuFphaoByDdhao(str,item.code).then(rd => {
				        console.log("rd=======",rd)
						// this.getgldata();
						this.getddhxinxi();
				    });
				})
				
				// this.linklists.splice(index,1)
			},
			// 解绑后
			delfpgsddh(item,items){
				this.$msg.confirm("确认解绑该条发票号？",()=>{
				    ss.orderCgService.jiechuFphaoByDdhao(items,item.code).then(rd => {
				        console.log("rd=======",rd)
						this.getgldata();
				    });
				})
				// this.linklists[index1].fphobj.list.splice(index2,1)
			},
			// 解绑前
			delfkddsfph(item){
				console.log(item.list)
				this.$msg.confirm("确认全部解绑与该发票号关联的订单号？",()=>{
					var str = '';
					for(var i=0;i<item.list.length;i++){
						str += item.list[i]+';'
					}
					// this.getfphxinxi()
				    ss.orderCgService.jichuDdhaoByFphao(item.code,str).then(rd => {
				        console.log("rd=======",rd)
						// this.shuju()
						this.getfphxinxi()
				    });
				})
			},
			// 解绑后
			delfpgsfph(item,items){
				this.$msg.confirm("确认解绑该条订单号？",()=>{
				    ss.orderCgService.jichuDdhaoByFphao(item.code,items).then(rd => {
				        console.log("rd=======",rd)
						this.getgldata();
				    });
				})
			},
			// 添加发票号
			addfph(code){
				this.fkddcode = code;
				console.log(code)
				this.q2.code = '';
				this.dialogFormVisible4 = true;
				//查询发票列表
				this.queryfp()
			},
			// 添加付款订单
			addfkdd(code){
				this.fphcode = code;
				console.log(code)
				this.q1.code = '';
				this.dialogFormVisible3 = true;
				//查询订单分页
				this.querydd()
			},
			// 取消
			cancel3(){
				this.dialogFormVisible3 = false;
			},
			// 确认
			saveTo3(){
				this.dialogFormVisible3 = false;
			},
			// 取消
			cancel4(){
				this.dialogFormVisible4 = false;
			},
			// 确认
			saveTo4(){
				this.dialogFormVisible4 = false;
			},
			// 搜索发票号
			search2(){
				this.q2.invoiceNo = this.q2.code;
				this.queryfp()
			},
			// 搜索订单号
			search1(){
				this.querydd()
			},
			// 根据发票栏信息更新订单号信息
			getfphxinxi(){
				var str = '';
				for(var i=0;i<this.tableData2.length;i++){
					str += this.tableData2[i].invoiceNo+';'
				}
				ss.orderCgService.selectFph(str).then(rd => {
				    console.log("rd=======",rd)
				    var obj1 = {};
				    var obj2 = {};
				    for(var i=0;i<rd.length;i++){
						if(rd[i].code || rd[i].totalPrice){
							this.tableData1.push({
								code:rd[i].code,
								totalPrice:rd[i].totalPrice
							})
						}else{
							this.tableData1 = [];
						}
				    	
				    	if(rd[i].invoiceNo || rd[i].fpje || rd[i].invoiceDate){
				    		this.tableData2.push({
				    			invoiceNo:rd[i].invoiceNo,
				    			fpje:rd[i].fpje,
				    			invoiceDate:rd[i].invoiceDate,
				    		})
				    	}else{
				    		this.tableData2 = [];
				    	}
				    	
				    }
				    this.tableData1 = this.distinct(this.tableData1);
				    this.tableData2 = this.distinct(this.tableData2);
					this.getgldata();
				    console.log(this.tableData2,"//////")
				});
			},
			// 根据订单栏信息更新发票号信息
			getddhxinxi(){
				var str = '';
				for(var i=0;i<this.tableData1.length;i++){
					str += this.tableData1[i].code+';'
				}
				this.infkdd(str);
			},
			// 选择付款订单
			select1(){
				if(this.multipleSelection3 && this.multipleSelection3.length>0){
					var str = '';
					for(var i=0;i<this.multipleSelection3.length;i++){
						str += this.multipleSelection3[i].code +';'
					}
					ss.orderCgService.guanlianddh(this.fphcode,str).then(rd => { 
						console.log("rd=======",rd)
						this.getfphxinxi()
						// this.getddhxinxi()
						this.dialogFormVisible3 = false;
					});
				}
				
			},
			// 选择发票号
			select2(){
				if(this.multipleSelection4 && this.multipleSelection4.length>0){
					var str = '';
					for(var i=0;i<this.multipleSelection4.length;i++){
						str += this.multipleSelection4[i].invoiceNo +';'
					}
					ss.orderCgService.guanlianfph(str,this.fkddcode).then(rd => { 
						console.log("rd=======",rd)
						this.getddhxinxi()
						// this.getfphxinxi()
						this.dialogFormVisible4 = false;
					});
				}
			}
		}
	}
</script>

<style scoped>
	.l-linkBox{
		display: flex;
	}
	.l-linkl{
		width: 6.2rem;
	}
	.l-linkscreen{
		display: flex;
		align-items: center;
		margin-bottom: 0.24rem;
		flex-shrink: 0;
	}
	.l-linkinput{
		width: 4rem;
		margin: 0 0.3rem;
		margin-left: 0.2rem;
		flex-shrink: 0;
	}
	.l-linktext{
		font-size: 16px;
		color: #616467;
		flex-shrink: 0;
	}
	.l-linkc{
		width: 1.5rem;
		padding: 0 2%;
	}
	.l-linkgls{
		background-color: #0e76e9;
		border-radius: 0.1rem;
		padding: 0.1rem;
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 0.16rem;
		color: #fff;
		cursor: pointer;
	}
	.l-linkr{
		width: 7.6rem;
	}
	.l-linkg{
		width: 6.2rem;
	}
	.l-linkgtext{
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0.1rem;
		color: #323232;
		font-size: 0.16rem;
		border-bottom: 1px solid #dedede;
	}
	.l-linkg.l-linkf{
		width: 7.6rem;
		margin-left: 1.5rem;
	}
	.fklistBox{
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		margin-top: 0.24rem;
	}
	.fklists,.fklistss{
		width: 1.3rem;
		padding: 0 0.05rem;
		margin-left: 0.2rem;
		background: #d9e9f3;
		height: 0.3rem;
		line-height: 0.3rem;
		color: #6d829c;
		margin-bottom: 0.14rem;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 0.14rem;
		cursor: pointer;
	}
	.fklists.active,.fklistss.active{
		background: #95cdff;
		color: #fff;
	}
	.fklists:nth-child(4n+1){
		margin-left: 0;
	}
	.fklistss:nth-child(5n+1){
		margin-left: 0;
	}
	.l-linkresultbox{
		width: 100%;
		padding: 0.4rem;
		border: 1px solid #d9e5f1;
		color: #4a4a4a;
		font-size: 0.16rem;
	}
	.l-linkresults{
		display: flex;
		margin-bottom: 0.2rem;
	}
	.l-linkresultl{
		display: flex;
		flex-shrink: 0;
	}
	.l-linkresultltext{
		margin-right: 0.1rem;
		flex-shrink: 0;
	}
	.l-linkresultlnumstext{
		margin-right: 0.1rem;
	}
	.l-linkresultlnums{
		display: flex;
		height: 0.23rem;
		border-bottom: 1px solid #dedede;
		padding-left: 0.1rem;
		margin-bottom: 0.1rem;
	}
	.l-linkresultc{
		margin: 0 0.3rem;
		flex-shrink: 0;
	}
	.l-linkresultr{
		display: flex;
		flex-wrap: wrap;
	}
	.l-rights{
		margin-right: 0.2rem;
	}
	.el-icon-my-dians{
		background: url(../../assets/images/l_dian.png) center no-repeat;
		background-size: cover;
		width: 0.14rem;
		height: 0.14rem;
	}
	.l_linkqiehuan{
		display: flex;
		align-items: center;
		margin-bottom: 0.2rem;
	}
	.l_linkqies{
		width: 1.2rem;
		height: 0.44rem;
		line-height: 0.42rem;
		text-align: center;
		color: #b8c1d4;
		font-size: 0.16rem;
		background: #fff;
		border: 1px solid #d7e0f1;
		cursor: pointer;
		border-top-left-radius: 0.02rem;
		border-bottom-left-radius: 0.02rem;
	}
	.l_linkqies:nth-child(2){
		border-top-right-radius: 0.02rem;
		border-bottom-right-radius: 0.02rem;
	}
	.l_linkqies.active{
		border-color: #59b0ff;
		background: #59b0ff;
		color: #fff;
	}
	.l_linkimgs{
		margin-top: -0.05rem;
		cursor:pointer;
		flex-shrink: 0;
	}
</style>
<style>
	.l-formlines .h-dialogForm .h-elformWrap-2 .el-form-item__label{
		width: 30%;
	}
	.l_timeline .el-timeline-item__node--large{
		background: url(../../assets/images/l_dian.png) center no-repeat;
		background-size: cover;
		width: 0.14rem;
		height: 0.14rem;
	}
	.ljjdiolog .el-dialog__body{
		padding: 0px 20px;
	}
	.ljjpaginations .el-pagination__sizes{
		display: none!important;
	}
	.ljjpaginations .el-pagination__jump{
		display: none!important;
	}
</style>